// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, type User } from 'firebase/auth';
import { getDatabase, ref, set, update } from 'firebase/database';

const firebaseConfig = {
  apiKey: 'AIzaSyBDBHUmBJA_mjiR4wPAJKN1AonExxLrGt0',
  authDomain: 'trackla.firebaseapp.com',
  databaseURL: 'https://trackla-default-rtdb.europe-west1.firebasedatabase.app',
  projectId: 'trackla',
  storageBucket: 'trackla.firebasestorage.app',
  messagingSenderId: '921848839672',
  appId: '1:921848839672:web:a6086fc0185ec82932ea0d',
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

export const rtdb = getDatabase();
export const fsdb = getFirestore(app);
export const auth = getAuth();

export const usersRef = (path?: string) => ref(rtdb, path ? `users/${path}` : 'users');
export const updateUserData = (user: User) => {
  if (!auth.currentUser) return;

  set(usersRef(auth.currentUser.uid), {
    uid: user.uid,
    email: user.email,
    displayName: user.displayName ?? 'Anonymous',
    photoURL: user.photoURL,
  });
};

export const onlineUsersRef = (path?: string) => ref(rtdb, path ? `online-users/${path}` : 'online-users');

export const updateUserLocation = (geoLocation: GeolocationPosition) => {
  if (!auth.currentUser) return;

  update(onlineUsersRef(auth.currentUser.uid), geoLocation.toJSON());
};
